<template>
  <div class="flex flex-col h-screen overflow-hidden bg-[#e8e5de]">
    <nav
      class="w-full flex items-center justify-between px-4 md:px-6 bg-white shadow-sm border-b border-gray-200 h-14"
    >
      <div class="flex items-center text-gray-700">
        <button
          @click="isSidebarOpen = !isSidebarOpen"
          class="lg:hidden mr-4 p-2 focus:outline-none focus:ring-2 focus:ring-orange-200 rounded"
        >
          <i class="fas fa-bars text-xl cursor-pointer"></i>
        </button>
      </div>

      <img
        :src="displayLogo"
        alt="Logo entreprise"
        :class="logoClass"
      />
    </nav>

    <div
      class="w-full h-20 bg-black flex items-center justify-between px-4 md:px-6"
    >
      <div
        class="flex items-center space-x-2 md:space-x-3 text-white font-semibold text-lg"
      >
        <i class="fas fa-user-circle text-4xl md:text-5xl"></i>
        <span class="md:inline">{{ username }}</span>
      </div>

      <div class="text-gray-300 font-semibold text-sm md:text-lg">
        {{ formattedDate }}
      </div>

      <img
        src="@/assets/nom_G.png"
        alt="Logo Sazience"
        class="h-4 w-auto object-contain md:h-5"
      />
    </div>

    <div class="flex flex-1 overflow-hidden">
      <div
        v-if="isSidebarOpen"
        @click="isSidebarOpen = false"
        class="fixed inset-0 z-30 lg:hidden"
      ></div>

      <aside
        :class="{
          'translate-x-0': isSidebarOpen,
          '-translate-x-full': !isSidebarOpen,
        }"
        class="w-64 bg-[#ec4400] text-white flex flex-col shadow-md z-40 transform transition-transform duration-300 ease-in-out fixed top-[8.5rem] bottom-0 left-0 md:w-80 lg:translate-x-0"
      >
        <nav class="flex-1 p-4 overflow-y-auto">
          <ul class="space-y-1">
            <li v-if="authStore.user && authStore.user.modules && authStore.user.modules.visitors" class="relative">
              <button
                @click="
                  currentView = 'VisitorDashboard';
                  isSidebarOpen = false;
                "
                :class="[
                  'flex items-center w-full text-left px-4 py-3 text-base rounded-lg transition-colors duration-200',
                  currentView === 'VisitorDashboard'
                    ? 'bg-orange-950 text-white font-bold'
                    : 'hover:bg-orange-950 hover:bg-opacity-10',
                ]"
              >
                Visiteurs
              </button>
            </li>
            <li v-if="authStore.user && authStore.user.modules && authStore.user.modules.visitor_vehicles" class="relative">
              <button
                @click="
                  currentView = 'CarDashboard';
                  isSidebarOpen = false;
                "
                :class="[
                  'flex items-center w-full text-left px-4 py-3 text-base rounded-lg transition-colors duration-200',
                  currentView === 'CarDashboard'
                    ? 'bg-orange-950 text-white font-bold'
                    : 'hover:bg-orange-950 hover:bg-opacity-10',
                ]"
              >
                Véhicules visiteurs
              </button>
            </li>
            <li v-if="authStore.user && authStore.user.modules && authStore.user.modules.staff_vehicles" class="relative">
              <button
                @click="
                  currentView = 'StaffVehiclesDashboard';
                  isSidebarOpen = false;
                "
                :class="[
                  'flex items-center w-full text-left px-4 py-3 text-base rounded-lg transition-colors duration-200',
                  currentView === 'StaffVehiclesDashboard'
                    ? 'bg-orange-950 text-white font-bold'
                    : 'hover:bg-orange-950 hover:bg-opacity-10',
                ]"
              >
          Véhicules personnels
              </button>
            </li>
            <!-- New: Company Management for Superadmin -->
            <li v-if="authStore.user && authStore.user.role === 'superadmin'" class="relative">
              <button
                @click="
                  currentView = 'CompanyManagementView';
                  isSidebarOpen = false;
                "
                :class="[
                  'flex items-center w-full text-left px-4 py-3 text-base rounded-lg transition-colors duration-200',
                  currentView === 'CompanyManagementView'
                    ? 'bg-orange-950 text-white font-bold'
                    : 'hover:bg-orange-950 hover:bg-opacity-10',
                ]"
              >
                <i class="fas fa-building mr-4 text-xl"></i> Gestion Clients
              </button>
            </li>
            <li v-if="authStore.user && authStore.user.role === 'superadmin'" class="relative">
              <button
                @click="
                  currentView = 'DepartmentsManagementView';
                  isSidebarOpen = false;
                "
                :class="[
                  'flex items-center w-full text-left px-4 py-3 text-base rounded-lg transition-colors duration-200',
                  currentView === 'DepartmentsManagementView'
                    ? 'bg-orange-950 text-white font-bold'
                    : 'hover:bg-orange-950 hover:bg-opacity-10',
                ]"
              >
                <i class="fas fa-sitemap mr-4 text-xl"></i> Gestion Départements
              </button>
            </li>
            <li v-if="authStore.user && authStore.user.role === 'superadmin'" class="relative">
              <button
                @click="
                  currentView = 'BadgesManagementView';
                  isSidebarOpen = false;
                "
                :class="[
                  'flex items-center w-full text-left px-4 py-3 text-base rounded-lg transition-colors duration-200',
                  currentView === 'BadgesManagementView'
                    ? 'bg-orange-950 text-white font-bold'
                    : 'hover:bg-orange-950 hover:bg-opacity-10',
                ]"
              >
                <i class="fas fa-id-badge mr-4 text-xl"></i> Gestion Badges
              </button>
            </li>
            <li v-if="authStore.user && authStore.user.role === 'superadmin'" class="relative">
              <button
                @click="
                  currentView = 'VisitedPeopleManagementView';
                  isSidebarOpen = false;
                "
                :class="[
                  'flex items-center w-full text-left px-4 py-3 text-base rounded-lg transition-colors duration-200',
                  currentView === 'VisitedPeopleManagementView'
                    ? 'bg-orange-950 text-white font-bold'
                    : 'hover:bg-orange-950 hover:bg-opacity-10',
                ]"
              >
                <i class="fas fa-user-tie mr-4 text-xl"></i> Gestion Personnel
              </button>
            </li>
            <li v-if="authStore.user && authStore.user.role === 'superadmin'" class="relative">
              <button
                @click="
                  currentView = 'UserManagementView';
                  isSidebarOpen = false;
                "
                :class="[
                  'flex items-center w-full text-left px-4 py-3 text-base rounded-lg transition-colors duration-200',
                  currentView === 'UserManagementView'
                    ? 'bg-orange-950 text-white font-bold'
                    : 'hover:bg-orange-950 hover:bg-opacity-10',
                ]"
              >
                <i class="fas fa-users-cog mr-4 text-xl"></i> Gestion Utilisateurs
              </button>
            </li>
          </ul>
        </nav>

        <div class="p-4 border-t border-orange-700 flex justify-center">
          <button
            @click="logout"
            class="bg-red-600 text-white px-3 py-2 rounded hover:bg-red-700 text-sm"
          >
            Déconnexion
          </button>
        </div>
      </aside>

      <main class="flex-1 flex flex-col overflow-y-auto lg:ml-80">
        <div class="p-4 md:p-6">
          <component :is="currentView" />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/features/auth/auth.store";
import VisitorDashboard from "./components/VisitorDashboard.vue";
import CarDashboard from "./components/CarDashboard.vue";
import StaffVehiclesDashboard from "./components/StaffVehiclesDashboard.vue";
import CompanyManagementView from "../companyManagement/CompanyManagementView.vue";
import DepartmentsManagementView from "../companyManagement/DepartmentsManagementView.vue";
import BadgesManagementView from "../companyManagement/BadgesManagementView.vue";
import VisitedPeopleManagementView from "../companyManagement/VisitedPeopleManagementView.vue";
import UserManagementView from "../userManagement/UserManagementView.vue"; // Import UserManagementView
import Sazience_O_Logo from "@/assets/Sazience_O.png";
import NinetyOneOne_Logo from "@/assets/911.png";


export default {
  name: "DashboardLayout",
  components: {
    VisitorDashboard,
    CarDashboard,
    StaffVehiclesDashboard,
    CompanyManagementView,
    DepartmentsManagementView,
    BadgesManagementView,
    VisitedPeopleManagementView,
    UserManagementView,
  },
  setup() {
    const router = useRouter();
    const authStore = useAuthStore(); // Use auth store

    const currentView = ref("");
    const isSidebarOpen = ref(false);
    const username = ref("");
    // enabledModules will be directly from authStore.user.modules
    // userRole will be directly from authStore.user.role

    const formattedDate = computed(() => {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return new Date().toLocaleDateString("fr-FR", options);
    });

    const displayLogo = computed(() => {
      // Assuming authStore.user.company holds the company name
      if (authStore.user && authStore.user.company === 'BM') {
        return NinetyOneOne_Logo;
      }
      return Sazience_O_Logo;
    });

    const logoClass = computed(() => {
      if (authStore.user && authStore.user.company === 'BM') {
        return 'h-30 w-auto'; // For 911.png
      }
      return 'h-12 w-auto'; // For Sazience_O.png
    });

    const logout = () => {
      authStore.logout(); // Use Pinia store for logout
    };

    onMounted(() => {
      authStore.checkAuthStatus(); // Ensure auth state is loaded

      if (authStore.isAuthenticated && authStore.user) {
        username.value = authStore.user.username;
        // The sidebar v-if will now directly use authStore.user.role and authStore.user.modules

        // Set the default view based on user role and enabled modules
        if (authStore.user.role === 'superadmin') { // Superadmin defaults to Company Management or User Management
          // Prefer Company Management if that was the prior default
          if (authStore.user.modules && authStore.user.modules.companyManagement) {
            currentView.value = 'CompanyManagementView';
          } else {
            currentView.value = 'UserManagementView'; // Default to User Management if no other superadmin view
          }
        } else if (authStore.user.modules && authStore.user.modules.visitors) {
          currentView.value = 'VisitorDashboard';
        } else if (authStore.user.modules && authStore.user.modules.visitor_vehicles) {
          currentView.value = 'CarDashboard';
        } else if (authStore.user.modules && authStore.user.modules.staff_vehicles) {
          currentView.value = 'StaffVehiclesDashboard';
        }
      }
    });

    // We no longer need to return enabledModules and userRole from setup()
    // as they can be accessed directly from authStore in the template.
    return {
      currentView,
      isSidebarOpen,
      formattedDate,
      username,
      logout,
      displayLogo,
      logoClass,
      NinetyOneOne_Logo,
      Sazience_O_Logo,
            // Pass authStore to template so v-if can access user.role and user.modules
            authStore,
            router, // Expose router to the template
          };  },
};
</script>

<style>
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css");

body {
  font-family: "Nunito", sans-serif;
}
</style>
